import { Poppins, Quicksand } from 'next/font/google';
import Image from 'next/image';
import React from 'react';
import EnquiryForm from './contactus/Enquiry-form';

const popins = Poppins({  weight: ["500", "400",'600'], subsets: ['latin'] });

export default function ContactDetails() {
  const ContactDetailsData = [
    {
      icon: "/contact-img/location-icon.svg",
      title: "Thoraipakkam",
      placeDetails: "No.4/643,ADM Tower 2nd Floor,VOC street, OMR, Thoraippakkam,Chennai-600097",
      mobileNumber:"7825 88 88 99"
    },
    {
      icon: "/contact-img/location-icon.svg",
      title: "Keelkattalai",
      placeDetails: "Second Floor, S.V Mini Hall, No:8, 2nd Main Rd, Duraisamy Nagar, Keelkattalai, Chennai-600117",
     mobileNumber:"7825 88 88 44"
    },
    {
      icon: "/contact-img/location-icon.svg",
      title: "Ashok Pillar",
      placeDetails: "No 32, 12th Avenue Ashok nagar, chennai - 600083",
       mobileNumber:"7825 88 88 55"
    },
    {
      icon: "/contact-img/location-icon.svg",
      title: "Tirunelveli",
      placeDetails: "No.181A/30/2, Malha Allah Complex, S.N High Road, Sripuram, Tirunelveli - 627007",
       mobileNumber:"7825 88 88 66"
    },
  ];

  const GooglMap = [
    {
      title:"Thoraipakkam",
      mapLink:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.6259012793366!2d80.22811697024966!3d12.931748887884815!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525cf7e5bd3dcb%3A0x99d794a7e09d7d98!2sADM%20Tower%2C%204%2F643%2C%20VO%20Chidambaranaar%20St%2C%20Muttukkaranchavadi%2C%20Thoraipakkam%2C%20Tamil%20Nadu%20600097!5e0!3m2!1sen!2sin!4v1729147839531!5m2!1sen!2sin"
    },
    {
      title:"Keelakattalai",
      mapLink:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.273621774156!2d80.18327987025219!3d12.954335087345296!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525dd806717965%3A0x4d27db99d0bd6f4e!2s8%2C%202nd%20Main%20Rd%2C%20Soundararajan%20Nagar%2C%20Keelkattalai%2C%20Chennai%2C%20Tamil%20Nadu%20600117!5e0!3m2!1sen!2sin!4v1729148382955!5m2!1sen!2sin"
    },
    {
      title:"Ashok Pillar",
      mapLink:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.0788644352315!2d80.20886367405156!3d13.030649713582985!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52671f124ff3e1%3A0xa6102dc07f790501!2s32%2C%2012th%20Ave%2C%20R.V.%20Nagar%2C%20Mettuppalayam%2C%20West%20Jafferkhanpet%2C%20Chennai%2C%20Tamil%20Nadu%20600083!5e0!3m2!1sen!2sin!4v1729148468985!5m2!1sen!2sin"
    },
    {
      title:"Tiruneveli",
      mapLink:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3943.611002132829!2d77.70044647399307!3d8.728437093623462!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b0411ff219b201b%3A0x2127fbc0954c3099!2slearnsoft.org!5e0!3m2!1sen!2sin!4v1729148607989!5m2!1sen!2sin"
    },
  ]

  return (
    <>
      <section className='container'>
        <div className='mt70 mmt20'>
          <div className='df gap10 tfdc'>
            {ContactDetailsData.map((item, index) => (
              <div className='detail-box' key={index}>
                <div className='df gap8'>
                  <Image src={item.icon} width={30} height={30} alt={item.title} loading='lazy' />
                  <p className={`fs-24 mfs-19 ${popins.className}`}>{item.title}</p>
                </div>
                <div className='mt30'>

                      <p className={`fs-16 mfs-14 pdt10 place ${popins.className}`}>{item.placeDetails}</p>
                      <div className='mt16 df fac gap10'>
                      <Image src={"/contact-img/phone-icon.svg"} width={30} height={30} alt='Phone-Icon' loading='lazy'/>
                      <p className={`fs-14 fwb400  ${popins.className}`}>Ph.No : {item.mobileNumber}</p>
                      </div>
                      <div className='mt16 df fac gap10'>
                      <Image src={"/contact-img/mail-icon.svg"} width={30} height={30} alt='Phone-Icon' loading='lazy'/>
                      <p className={`fs-14 fwb400  ${popins.className}`}>Mail Id: contact@learnsoft.org</p>
                      </div>

                </div>
              </div>
            ))}
          </div>
          <EnquiryForm/>
          <div className='mt70 mb40'>
          <h1 className={`fs-33 mfs-19 cb tac fwb600 ${popins.className}`}> Our <span className='ylw-clr'> Locations </span></h1>
           <div className='df mt32 gap20 tfdc'>
            {GooglMap.map((items,index)=>{
              return(
            <div className=''>
              <p className={`fs-24 mfs-19 tac fwb600 ${popins.className}`}>{items.title}</p>
           <iframe className='google-map mt14'   src={items.mapLink} width="290" height="252"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
           </div>
           )
          })}
           </div>
           </div>
        </div>
      </section>
      <style jsx>
        {`
     .google-map {
        width: 280px;
        height: 252px;
        border-radius: 10px;
        border: 10px solid #fff;
        box-shadow: 0px 4px 16px 0px #00000040;

      }

      .place{
      height: 60px;
      }
          .detail-box {
            background-color: #F0F4F9;
            width: 295px;
            border-radius: 10px;
            padding: 10px 0px 10px 10px;
          }
                 @media only screen and (max-width: 1250px){
              .tfdc{
              display: flex;
              flex-direction: column;
              align-items: center;
              }
      .place{
          height: auto;
       }
        }
              @media only screen and (max-width: 468px){
                     .detail-box {
            background-color: #F0F4F9;
            width: 100%;
            border-radius: 10px;
            padding: 10px 0px 10px 10px;
          }
              }
        
        `}
      </style>
    </>
  );
}
